"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadSupportedLanguages = exports.FetchSupportedLanguages = exports.FetchSupportedLanguagesActionTypes = exports.SupportedLanguagesActionTypes = void 0;

var _fluxActions = require("flux-actions");

var _actions = require("settings-ui-sdk/utils/actions");

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-sdk/utils/namespacedKeyMirror"));

var SupportedLanguagesActionTypes = (0, _namespacedKeyMirror.default)({
  LOAD_SUPPORTED_LANGUAGES: null,
  FETCH_SUPPORTED_LANGUAGES: null
}, 'shared');
exports.SupportedLanguagesActionTypes = SupportedLanguagesActionTypes;
var FetchSupportedLanguagesActionTypes = (0, _actions.createRequestTypes)(SupportedLanguagesActionTypes.FETCH_SUPPORTED_LANGUAGES);
exports.FetchSupportedLanguagesActionTypes = FetchSupportedLanguagesActionTypes;
var FetchSupportedLanguages = (0, _actions.createRequestActions)(FetchSupportedLanguagesActionTypes);
exports.FetchSupportedLanguages = FetchSupportedLanguages;
var loadSupportedLanguages = (0, _fluxActions.createAction)(SupportedLanguagesActionTypes.LOAD_SUPPORTED_LANGUAGES);
exports.loadSupportedLanguages = loadSupportedLanguages;